import React from "react"
import styles from "./blockImgTextMarginTop.module.css"

const BlockImgTextMarginTop = ({ bgColor, data }) => {
  const {
    title,
    text,
    img: {
      uri: { url: image },
    },
  } = data

  return (
    <section className={styles.blockImgTextMarginTop}>
      <div className={styles.blockImgTextMarginTop__img}>
        <img src={`https://drupal.smartempo.com${image}`} alt={title} />
      </div>
      <div className={styles.blockImgTextMarginTop__titleText}>
        <h3>{title}</h3>
        <div dangerouslySetInnerHTML={{ __html: text }} />
      </div>
    </section>
  )
}
export default BlockImgTextMarginTop
